import request from '@/utils/request'
import { Base64 } from 'js-base64'

export function getAuthorizationList(data) {
  return request({
    url: `${context.gatewayUrl}/bpm-form/AuthorizationCenter/v1/list`,
    method: 'post',
    data: data,
  })
}
export function getAuthorizationCenterCount(empNo) {
  return request({
    url: `${context.gatewayUrl}/bpm-form/AuthorizationCenter/v1/count/${empNo}`,
    method: 'get',
  })
}
/**
 * 获取职位名称
 */
export function getObtainPosition(empNo) {
  return request({
    url: `${context.gatewayUrl}/bpm-form/AuthorizationCenter/v1/post/${empNo}`,
    method: 'get',
  })
}

/**
 * 获取流程详细信息
 */
export function getFlowInfo(data) {
  return request({
    url: `${context.gatewayUrl}/bpm-form/AuthorizationCenter/v1/flowInfo`,
    method: 'post',
    data,
  })
}

export function getOrganizationList(empNo) {
  return request({
    url: `${context.gatewayUrl}/bpm-form/AuthorizationCenter/v1/personnel/${empNo}`,
    method: 'post',
    data: {},
  })
}
export function searchUserList(data) {
  return request({
    url: `${context.gatewayUrl}/bpm-uc/api/user/v1/users/queryUserWithMainOrgPost`,
    method: 'post',
    data: Base64.encode(JSON.stringify(data)),
  })
}

/**
 * 获取数量
 */
export function getPieList(data) {
  return request({
    url: `${context.gatewayUrl}/bpm-form/AuthorizationCenter/v1/count`,
    method: 'post',
    data: data,
  })
}

/**
 *
 * @param {*} data
 * @returns
 */
export function getProcessList(data) {
  return request({
    url: `${context.gatewayUrl}/bpm-form/AuthorizationCenter/v1/list`,
    method: 'post',
    data,
  })
}

/**
 *@description
 * @param {*} data
 * @returns
 */
export function getSupperList(data) {
  return request({
    url: `${context.gatewayUrl}/bpm-form/AuthorizationCenter/v1/listByLevel`,
    method: 'post',
    data,
  })
}
